import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.alramlaa.com";

export function OrganizationJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "الرملاء للصناعات الخشبية",
    alternateName: "Al Ramlaa Wooden Products",
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    sameAs: [
      "https://www.facebook.com/people/Alramlaa-Wooden-Products/61583094580752/",
      "https://www.instagram.com/alramlaa.official/",
      "https://www.linkedin.com/in/alramlaa-wooden-products-513276293/",
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

/**
 * @param product StoreProduct API shape (name/arName/description/arDescription/price/discount_percentage/image/images/inStock)
 * @param displayName already-localized name (see localizedStoreProductName)
 * @param displayDescription already-localized description
 * @param finalPrice final unit price (after discount) to report as the offer price
 * @param path e.g. `/store/product/${product._id}`
 */
function toAbsolute(url) {
  if (!url) return "";
  return url.startsWith("http") ? url : `${SITE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}

export function ProductJsonLd({ product, displayName, displayDescription, finalPrice, path }) {
  if (!product) return null;

  const images = (
    Array.isArray(product.images) && product.images.length
      ? product.images.map((img) => img.url).filter(Boolean)
      : product.image?.url
      ? [product.image.url]
      : []
  ).map(toAbsolute);

  const data = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: displayName || product.name,
    description: displayDescription || product.description || undefined,
    image: images.length ? images : undefined,
    sku: product.sku || undefined,
    brand: product.brand ? { "@type": "Brand", name: product.brand } : undefined,
    offers: {
      "@type": "Offer",
      url: `${SITE_URL}${path}`,
      priceCurrency: "SAR",
      price: finalPrice != null ? String(finalPrice) : undefined,
      availability: product.inStock !== false
        ? "https://schema.org/InStock"
        : "https://schema.org/OutOfStock",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
